<template>
  <div class="lightbox-security">
    <div class="lightbox-security__inner">
      <h2 class="lightbox-security__ttl">セキュリティコードについて</h2>
      <div class="visa-amex">
        <img src="/static/img/amex.png" alt="">
        <img src="/static/img/visa.png" alt="">
      </div>
      <p class="lightbox-security__sentence">セキュリティコードはクレジットカード裏面末尾3桁の数字です。<br>（一部のクレジットカードの場合、カード表面右側にある4桁の数字となります。）</p>
      <div class="security-bottom">
        <p><a href="#" @click="closeLightBox">閉じる</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      closeLightBox() {
        this.$store.dispatch("hideLightBox");
      }
    }
  }
</script>

<style scoped lang="scss">
  .lightbox-security {
    padding: 0 15px;
    &__inner {
      max-width: 440px;
      margin: 0 auto;
      padding: 10px 15px;
      background-color: #fff;
    }
    &__ttl {
      font-size: 18px;
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 20px;
    }
    &__sentence {
      padding-top: 15px;
      text-align: justify;
    }
  }
  .visa-amex {
    display: flex;
    justify-content: space-between;
    width: 300px;
    margin: 0 auto;
  }
  .security-bottom {
    padding: 20px 0 0;
    font-size: 16px;
    a {
      color: #FF5B60;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lightbox/AboutSecurity.vue